import firebase from 'firebase';

import { processQuerySnapshotItems } from './utils';
import { USERS } from '../collectionTypes';
import { USER_NOT_FOUND } from '../errorTypes';

const db = firebase.firestore();
const collection = db.collection(USERS);

export function getUser(uid) {
  return collection.doc(uid).get()
    .then(doc => (doc.exists ? doc.data() : Promise.reject(USER_NOT_FOUND)));
}

export function getUsers() {
  return collection.get()
    .then(processQuerySnapshotItems);
}

export function createUser(data, uid) {
  return collection.doc(uid).set(data)
    .then(() => getUser(uid));
}

export function updateUser(uid, updates) {
  return getUser(uid)
    .then(() => collection.doc(uid).update(updates));
}

export function watchUser(uid, callback) {
  return collection
    .doc(uid)
    .onSnapshot((doc) => { callback(doc.data()); });
}



// WEBPACK FOOTER //
// ./src/firebase/repositories/users.js